import {NgModule} from '@angular/core';
import {ComponentSetupService} from './component-setup.service';
import {CommonModule} from '@angular/common';
import {FormbirdServicesModule} from 'formbird-services';

@NgModule({
  declarations: [],
  imports: [CommonModule, FormbirdServicesModule ],
  exports: [],
  providers: [ComponentSetupService],
})

export class ComponentSetupModule {
}
